<template>
  <div class="bax-section bax-select-patient-wrap">
    <div class="container bax-wide">
      <div class="bax-bg bax-bg-foot-link bax-create-patient">
        <div class="default-mgr">
          <div
            v-if="
              !default_editing_showing && !substitution_editing_showing && !header_editing_showing
            "
          >
            <input
              type="button"
              color="link"
              class="bax-btn bax-btn-blue ml-auto mt-3 mt-md-0"
              @click.prevent="$emit('goBack')"
              value="Back To CSV Import"
            />
          </div>
          <div v-else>
            <input
              type="button"
              color="link"
              class="bax-btn bax-btn-blue ml-auto mt-3 mt-md-0"
              @click.prevent="backToImportHome()"
              value="Back"
            />
          </div>
          <h2>Customer Preference Wizard</h2>
          <div
            v-if="
              !default_editing_showing && !substitution_editing_showing && !header_editing_showing
            "
          >
            <BR /><BR />
            <div class="action-buttons">
              <input
                type="button"
                value="Manage Headers"
                class="bax-btn bax-btn-blue ml-auto mt-3 mt-md-0"
                @click="headerEdit(false)"
              />
              <input
                type="button"
                value="Manage Substitutions"
                class="bax-btn bax-btn-blue ml-auto mt-3 mt-md-0"
                @click="substitutionEdit(false)"
              />
              <input
                type="button"
                value="Manage Defaults"
                class="bax-btn bax-btn-blue ml-auto mt-3 mt-md-0"
                @click="defaultEdit(false)"
              />
            </div>
            <p>
              <strong>Headers</strong> are the mappings of the header names of your csv files to the
              names required by our import process
            </p>
            <p>
              <strong>Substitutions</strong> are words and phrases in your import files that we dont
              understand, and need to map to our words and phrases
            </p>
            <p>
              <strong>Defaults</strong> are the rules you can set up to change values of fields,
              based on other fields
            </p>
          </div>

          <div v-if="header_editing_showing">
            <defaults-headers />
          </div>
          <div v-if="substitution_editing_showing">
            <defaults-substitutions />
          </div>
          <div v-if="default_editing_showing">
            <h3>Manage Defaults</h3>
            <p>You can set up default values for the csv files you upload.</p>
            <p>
              Default settings can be used to set elements of the items that do not exist in your
              uploaded csv files.
            </p>
            <p v-if="default_editing === false">
              <input
                type="button"
                value="Create New"
                class="bax-btn bax-btn-blue ml-auto mt-3 mt-md-0"
                @click="defaultEdit(0)"
              />
            </p>
            <table class="default-list" v-if="default_editing === false">
              <template v-for="(did, i) in Object.keys(defaults)">
                <tr v-bind:key="i">
                  <td colspan="1" @click="defaultEdit(did)">
                    <span v-html="defaults[did].description"></span>
                    <div v-if="defaults[did].splits !== null && defaults[did].splits !== 0">
                      <span class="inline-block">Split dose</span> <span v-html="defaults[did].splits"></span> times if dose > max dose
                    </div>
                  </td>
                </tr>
                <tr v-bind:key="1000 + i" class="info-row">
                  <td>
                    Created by : {{ defaults[did].username }} on
                    {{ unix2date(defaults[did].created) }}
                  </td>
                </tr>
              </template>
            </table>
            <div v-if="default_editing !== false">
              <div>
                <h3>Conditions (when these conditions are true)</h3>
                <table>
                  <tr>
                    <td>Field</td>
                    <td>Operation</td>
                    <td>Value</td>
                  </tr>
                  <template v-for="(condition, index) in default_conditions">
                    <tr v-bind:key="index">
                      <td>
                        <select v-model="default_conditions[index].field">
                          <option
                            v-for="field_name in default_fields"
                            :value="field_name"
                            v-bind:key="field_name"
                          >
                            {{ field_name }}
                          </option>
                        </select>
                      </td>
                      <td>
                        <select v-model="default_conditions[index].operation">
                          <option value="EQ">=</option>
                          <option value="CO">CONTAINS</option>
                          <option value="LT">&lt;</option>
                          <option value="GT">&gt;</option>
                          <option value="BL">IS BLANK</option>
                        </select>
                      </td>
                      <td><input type="text" v-model="default_conditions[index].value" /></td>
                      <td>
                        <div class="bax-add-element">
                          <a
                            href="#"
                            v-if="index == 0"
                            @click.prevent="condition_add"
                            title="Add another row"
                          >
                            <i class="icon-add"></i>
                          </a>
                          <a
                            href="#"
                            v-if="index > 0"
                            @click.prevent="condition_remove(index)"
                            title="Remove row"
                          >
                            <i class="icon-delete"></i>
                          </a>
                        </div>
                      </td>
                    </tr>
                  </template>
                </table>
                <h3>Values (then set these values)</h3>
                <table>
                  <tr>
                    <td>Field</td>
                    <td>Value</td>
                  </tr>
                  <template v-for="(condition, index) in default_values">
                    <tr v-bind:key="index">
                      <td>
                        <select v-model="default_values[index].field">
                          <option
                            v-for="field_name in default_fields"
                            :value="field_name"
                            v-bind:key="field_name"
                          >
                            {{ field_name }}
                          </option>
                        </select>
                      </td>
                      <td><input type="text" v-model="default_values[index].value" /></td>
                      <td>
                        <div class="bax-add-element">
                          <a
                            href="#"
                            v-if="index == 0"
                            @click.prevent="value_add"
                            title="Add another row"
                          >
                            <i class="icon-add"></i>
                          </a>
                          <a
                            href="#"
                            v-if="index > 0"
                            @click.prevent="value_remove(index)"
                            title="Remove row"
                          >
                            <i class="icon-delete"></i>
                          </a>
                        </div>
                      </td>
                    </tr>
                  </template>
                </table>
                <h3>Split Dose</h3>
                <table>
                  <tr>
                    <td>Total</td>
                  </tr>
                  <template>
                    <tr>
                      <td>
                        <select v-model="selectedSplit">
                          <option v-for="split in totalSplits" :value="split" v-bind:key="split">
                            {{ split }}
                          </option>
                        </select>
                      </td>
                      <td>
                        <div class="bax-add-element">
                          <a
                            href="#"
                            v-if="index == 0"
                            @click.prevent="value_add"
                            title="Add another row"
                          >
                            <i class="icon-add"></i>
                          </a>
                          <a
                            href="#"
                            v-if="index > 0"
                            @click.prevent="value_remove(index)"
                            title="Remove row"
                          >
                            <i class="icon-delete"></i>
                          </a>
                        </div>
                      </td>
                    </tr>
                  </template>
                </table>
              </div>
              <div class="buttons">
                <input
                  type="button"
                  value="Cancel"
                  class="bax-btn bax-btn-bordered bax-btn-bordered-dark-gray-1"
                  @click="defaultCancel()"
                />
                <input
                  type="button"
                  value="Delete"
                  class="bax-btn bax-btn-danger ml-auto mt-3 mt-md-0"
                  @click="defaultSDelete()"
                />
                <input
                  type="button"
                  value="Save Default"
                  class="bax-btn bax-btn-blue ml-auto mt-3 mt-md-0"
                  @click="defaultSave()"
                />
              </div>
              <h3>Explorer</h3>
              <p>Use this tool to explore the database and find values that you can set.</p>
              <table class="drug-explorer">
                <tr>
                  <td>Drug 1 Name</td>
                  <td class="selector-col">
                    <v-autocomplete-select
                      label="title"
                      :options="this.drugs"
                      v-model="explorer.drug_1_name"
                    >
                      class="drug-selector">
                    </v-autocomplete-select>
                  </td>
                  <td class="actioncol">
                    <a @click.prevent="condition_add('drug_name', 'EQ', explorer.drug_1_name.title)"
                      >Add as Condition</a
                    >
                  </td>
                  <td class="actioncol">
                    <a @click.prevent="value_add('drug_name', explorer.drug_1_name.title)"
                      >Add as Value</a
                    >
                  </td>
                </tr>
                <tr v-if="drug_2_options && drug_2_options.length">
                  <td>Drug 2 Name</td>
                  <td>
                    <p v-if="!explorer.drug_1_name">Please choose Drug 1</p>
                    <select class="bax-input-control" v-model="explorer.drug_2_id">
                      <option v-for="(opt, i) in drug_2_options" :key="i" :value="i">
                        {{ opt }}
                      </option>
                    </select>
                  </td>
                  <td class="actioncol">
                    <a
                      @click.prevent="
                        condition_add('drug_name', 'EQ', drug_2_options[explorer.drug_2_id])
                      "
                      >Add as Condition</a
                    >
                  </td>
                  <td class="actioncol">
                    <a @click.prevent="value_add('drug_name', drug_2_options[explorer.drug_2_id])"
                      >Add as Value</a
                    >
                  </td>
                </tr>
                <tr v-if="admin_route_options && Object.keys(admin_route_options).length">
                  <td>Route of Administration</td>
                  <td>
                    <p v-if="!explorer.drug_1_name">Please choose Drug 1</p>

                    <select
                      id="route"
                      class="bax-input-control"
                      v-model="explorer.admin_route_code"
                    >
                      <option value="">- Select -</option>
                      <option v-for="(adminRoute, i) in admin_route_options" :key="i" :value="i">
                        {{ adminRoute }}
                      </option>
                    </select>
                  </td>
                  <td class="actioncol">
                    <a
                      @click.prevent="
                        condition_add('route', 'EQ', admin_route_options[explorer.admin_route_code])
                      "
                      >Add as Condition</a
                    >
                  </td>
                  <td class="actioncol">
                    <a
                      @click.prevent="
                        value_add('route', admin_route_options[explorer.admin_route_code])
                      "
                      >Add as Value</a
                    >
                  </td>
                </tr>
                <tr v-if="container_type_options && Object.keys(container_type_options).length">
                  <td>Container Type</td>
                  <td>
                    <p v-if="!explorer.drug_1_name">Please choose Drug 1</p>

                    <select
                      id="route"
                      class="bax-input-control"
                      v-model="explorer.container_type_id"
                    >
                      <option value="">- Select -</option>
                      <option v-for="(container, i) in container_type_options" :key="i" :value="i">
                        {{ container }}
                      </option>
                    </select>
                  </td>
                  <td class="actioncol">
                    <a
                      @click.prevent="
                        condition_add(
                          'container_type',
                          'EQ',
                          container_type_options[explorer.container_type_id]
                        )
                      "
                      >Add as Condition</a
                    >
                  </td>
                  <td class="actioncol">
                    <a
                      @click.prevent="
                        value_add(
                          'container_type',
                          container_type_options[explorer.container_type_id]
                        )
                      "
                      >Add as Value</a
                    >
                  </td>
                </tr>
                <tr v-if="diluent_options && Object.keys(diluent_options).length">
                  <td>Diluent</td>
                  <td>
                    <p v-if="!explorer.drug_1_name">Please choose Drug 1</p>

                    <select id="route" class="bax-input-control" v-model="explorer.diluent_id">
                      <option value="">- Select -</option>
                      <option v-for="(diluent, i) in diluent_options" :key="i" :value="i">
                        {{ diluent }}
                      </option>
                    </select>
                  </td>
                  <td class="actioncol">
                    <a
                      @click.prevent="
                        condition_add('diluent', 'EQ', diluent_options[explorer.diluent_id])
                      "
                      >Add as Condition</a
                    >
                  </td>
                  <td class="actioncol">
                    <a @click.prevent="value_add('diluent', diluent_options[explorer.diluent_id])"
                      >Add as Value</a
                    >
                  </td>
                </tr>
                <tr v-if="container_options && Object.keys(container_options).length">
                  <td>Container</td>
                  <td>
                    <p v-if="!explorer.drug_1_name">Please choose Drug 1</p>

                    <select id="route" class="bax-input-control" v-model="explorer.containerId">
                      <option value="">- Select -</option>
                      <option v-for="(container_desc, i) in container_options" :key="i" :value="i">
                        {{ container_desc.containerName }}
                      </option>
                    </select>
                  </td>
                  <td class="actioncol">
                    <a
                      @click.prevent="
                        condition_add(
                          'container',
                          'EQ',
                          container_options[explorer.containerId].containerName
                        )
                      "
                      >Add as Condition</a
                    >
                  </td>
                  <td class="actioncol">
                    <a
                      @click.prevent="
                        value_add(
                          'container',
                          container_options[explorer.containerId].containerName
                        )
                      "
                      >Add as Value</a
                    >
                  </td>
                </tr>
                <tr v-if="ancillary_1_options && Object.keys(ancillary_1_options).length">
                  <td>Ancillary 1</td>
                  <td>
                    <p v-if="!explorer.drug_1_name">Please choose Drug 1</p>

                    <select id="route" class="bax-input-control" v-model="explorer.ancillary_1">
                      <option value="">- Select -</option>
                      <option v-for="(ancillary, i) in ancillary_1_options" :key="i" :value="i">
                        {{ ancillary.genericName }}
                      </option>
                    </select>
                  </td>
                  <td class="actioncol">
                    <a
                      @click.prevent="
                        condition_add(
                          'ancillary',
                          'EQ',
                          ancillary_1_options[explorer.ancillary_1].genericName
                        )
                      "
                      >Add as Condition</a
                    >
                  </td>
                  <td class="actioncol">
                    <a
                      @click.prevent="
                        value_add(
                          'ancillary',
                          ancillary_1_options[explorer.ancillary_1].genericName
                        )
                      "
                      >Add as Value</a
                    >
                  </td>
                </tr>
                <tr v-if="ancillary_2_options && Object.keys(ancillary_2_options).length">
                  <td>Anciliary 2</td>
                  <td>
                    <p v-if="!explorer.drug_1_name">Please choose Drug 1</p>

                    <select id="route" class="bax-input-control" v-model="explorer.ancillary2">
                      <option value="">- Select -</option>
                      <option v-for="(ancillary, i) in ancillary_2_options" :key="i" :value="i">
                        {{ ancillary.genericName }}
                      </option>
                    </select>
                  </td>
                  <td class="actioncol">
                    <a
                      @click.prevent="
                        condition_add(
                          'ancillary2',
                          'EQ',
                          ancillary_2_options[explorer.ancillary2].genericName
                        )
                      "
                      >Add as Condition</a
                    >
                  </td>
                  <td class="actioncol">
                    <a
                      @click.prevent="
                        value_add(
                          'ancillary2',
                          ancillary_2_options[explorer.ancillary2].genericName
                        )
                      "
                      >Add as Value</a
                    >
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td>
                    <input
                      type="button"
                      value="Refresh"
                      class="bax-btn bax-btn-blue ml-auto mt-3 mt-md-0"
                      @click="explorer_reload()"
                    />
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CsvService from "@/core/api/csv/csv.service3";
import DrugService from "@/core/api/drug/drug.service";
import DefaultsHeaders from "./DefaultsHeaders.vue";
import DefaultsSubstitutions from "./DefaultsSubstitutions.vue";
import csvMixin from "./csvMixin";

export default {
  name: "Defaults",
  mixins: [csvMixin],
  components: {
    DefaultsHeaders,
    DefaultsSubstitutions,
  },
  props: ["uploadCode"],
  data() {
    return {
      default_editing: false,
      default_conditions: [],
      default_values: [],
      default_fields: [
        "comments",
        "comments2",
        "order_reference",
        "surname",
        "firstname",
        "dob",
        "patient_id",
        "quantity",
        "drug_name",
        "drug_dose",
        "drug_dose_unit",
        "drug2_name",
        "drug2_dose",
        "drug2_dose_unit",
        "diluent",
        "bag_size",
        "exact_volume",
        "container_type",
        "container",
        "route",
        "infusion_time",
        "infusion_time_unit",
        "ancillary",
        "ancillary2",
        "delivery_date",
        "delivery_time",
        "treatment_date",
        "treatment_time",
      ],
      drugs: [],
      drug_2_options: [],
      admin_route_options: [],
      container_type_options: [],
      container_options: [],
      diluent_options: [],
      ancillary_1_options: [],
      ancillary_2_options: [],
      explorer: {},
      defaults: [],
      header_editing_showing: false,
      default_editing_showing: false,
      substitution_editing_showing: false,
      totalSplits: [0, 1, 2, 3, 4],
      selectedSplit: null
    };
  },
  created() {
    this.loadDefaults();
  },
  methods: {
    async loadDefaults() {
      this.default_fields.sort();
      this.$watch("explorer", this.explorer_reload, { deep: true });
      if (this.drugs.length === 0) {
        const response = await DrugService.getAllDrugs();
        this.drugs = response.data;
      }
      CsvService.loadDefaults(3).then(async (res) => {
        this.defaults = res.data.defaults;
        this.drug_2 = [];
        this.admin_route_options = [];
        this.container_type_options = [];
        this.container_options = [];
        this.diluent_options = [];
        this.ancillary_1_options = [];
        this.ancillary_2_options = [];
      });
    },
    backToImportHome() {
      this.header_editing_showing = false;
      this.default_editing_showing = false;
      this.substitution_editing_showing = false;
    },
    defaultEdit(id) {
      this.header_editing_showing = false;
      this.default_editing_showing = true;
      this.substitution_editing_showing = false;
      if (id !== false) {
        this.default_editing = id;
        if (id === 0) {
          this.default_conditions = [{ field: "field", operation: "operation", value: "value" }];
          this.default_values = [{ field: "field", value: "value" }];
        } else {
          this.default_conditions = [];
          this.default_values = [];
          Object.keys(this.defaults[id].conditions).forEach((cid) => {
            this.default_conditions.push(this.defaults[id].conditions[cid]);
          });
          Object.keys(this.defaults[id].values).forEach((vid) => {
            this.default_values.push(this.defaults[id].values[vid]);
          });
        }
      }
    },
    substitutionEdit() {
      this.header_editing_showing = false;
      this.default_editing_showing = false;
      this.substitution_editing_showing = true;
    },
    headerEdit() {
      this.header_editing_showing = true;
      this.default_editing_showing = false;
      this.substitution_editing_showing = false;
    },
    defaultCancel() {
      this.default_editing = false;
      this.loadDefaults();
    },
    defaultSDelete() {
      const data = {};
      data.default_delete = this.default_editing;

      CsvService.deleteDefaults(data).then(async () => {
        this.default_editing = false;
        this.loadDefaults();
      });
    },
    defaultSave() {
      const data = {};
      data.default = this.default_editing;
      data.conditions = this.default_conditions;
      data.values = this.default_values;
      data.selectedSplit = this.selectedSplit

      CsvService.saveDefaults(data).then(async () => {
        this.default_editing = false;
        this.loadDefaults();
      });
    },
    condition_add(field, operation, value) {
      if (this.default_conditions[0].field === "field") {
        this.default_conditions[0] = { field, operation, value };
      } else {
        this.default_conditions.push({ field, operation, value });
      }
      this.$forceUpdate();
      // this.deliveryDate_recalc();
    },
    condition_remove(index) {
      this.default_conditions.splice(index, 1);
    },
    value_add(field, value) {
      if (this.default_values[0].field === "field") {
        this.default_values[0] = { field, value };
      } else {
        this.default_values.push({ field, value });
      }
      this.$forceUpdate();
      // this.deliveryDate_recalc();
    },
    value_remove(index) {
      this.default_values.splice(index, 1);
    },
    explorer_reload() {
      const data = {};
      data.explorer = this.explorer;

      CsvService.loadExplorer(data).then(async (results) => {
        const presdata = results.data;

        if (presdata.drug2) {
          this.drug_2_options = presdata.drug2.drug2_options;
        } else {
          this.drug_2_options = [];
        }

        if (presdata.admin_route_options) {
          this.admin_route_options = presdata.admin_route_options;
        } else {
          this.admin_route_options = [];
        }

        if (presdata.container_options) {
          this.container_type_options = presdata.container_options;
        } else {
          this.container_type_options = [];
        }

        if (presdata.diluent_options) {
          this.diluent_options = presdata.diluent_options;
        } else {
          this.diluent_options = [];
        }

        if (presdata.container_description_options) {
          this.container_options = presdata.container_description_options;
        } else {
          this.container_options = [];
        }
        if (presdata.ancillary_options) {
          this.ancillary_1_options = presdata.ancillary_options;
          this.ancillary_2_options = presdata.ancillary_options;
        } else {
          this.ancillary_1_options = [];
          this.ancillary_2_options = [];
        }
      });
    },
  },
};
</script>
